import '@popperjs/core';
import 'jquery';
import 'bootstrap';
import 'slick-carousel';

$(function () {
    let simpleCarousel = $('.simple-carousel');

    if (simpleCarousel.length > 0) {
        simpleCarousel.slick({
            dots: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 6,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                  }
                },
                {
                  breakpoint: 600,
                  settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4
                  }
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                  }
                }
              ]
        });
    }


    let carouselCenter = $('.carousel-center');

    if (carouselCenter.length > 0) {
        carouselCenter.slick({
            centerMode: true,
            dots: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
        });
    }


    $('#nav-tab a').on('click', function (e) {
        e.preventDefault();
        $(this).tab('show');
    });


    maps();
    news();
    menu();
});

function menu() {
    const $dropdown = $(".dropdown");
    const $dropdownToggle = $(".dropdown-toggle");
    const $dropdownMenu = $(".dropdown-menu");
    const showClass = "show";

    $(window).on("load resize", function() {
      if (this.matchMedia("(min-width: 768px)").matches) {
        $dropdown.hover(
          function() {
            const $this = $(this);
            $this.addClass(showClass);
            $this.find($dropdownToggle).attr("aria-expanded", "true");
            $this.find($dropdownMenu).addClass(showClass);
          },
          function() {
            const $this = $(this);
            $this.removeClass(showClass);
            $this.find($dropdownToggle).attr("aria-expanded", "false");
            $this.find($dropdownMenu).removeClass(showClass);
          }
        );
      } else {
        $dropdown.off("mouseenter mouseleave");
      }
    });
}

function news() {

    if($('#news-row').length == 0) {
        return;
    }

    $(document.body).on('click', '.pagination a' ,function(event) {
        event.preventDefault();
        loadNewsData($(this).prop('href'));
    });

}

function loadNewsData(href) {

    $('html,body').animate({scrollTop: $("#news-filter").offset().top - $('#header-wrapper').height() - 180 }, 100);
    $("#news-articles-layout-wrapper").append($('<div></div>').addClass('loading'));
    $("#news-articles-layout-wrapper").load(href+" #news-articles-layout");

    var stateObj = {};
    window.history.pushState(stateObj, "", href);
}



function maps()
{
    $('.js-goto-pin').on('click', function (e) {
        triggerClick($(this).data('id'));
    });
}